export const SET_ACCESS_TOKEN = "setAccessToken";
export const DELETE_ACCESS_TOKEN = "deleteAccessToken";
export const SET_REFRESH_TOKEN = "setRefreshToken";
export const DELETE_REFRESH_TOKEN = "deleteRefreshToken";
export const UPDATE_SECONDS_TO_EXPIRE = "updateSecondsToExpire";
export const SET_LOGGED_IN = "setLoggedIn";
export const SET_USER = "setUser";

export const SET_MESSAGE = "setMessage";
export const UNSET_MESSAGE = "unsetMessage";

export const SET_COLLECTION_SET = "setCollectionSet";
export const SET_PAYMENT_CHECKSUM = "setPyamentChecksum";

export const SET_ORDER_NUMBER = "setOrderNumber";

export const SET_PACKAGES = "setPackages";

export const SET_SURVEY = "setSurvey";
export const SET_COUNTRIES = "setCountries";
export const SET_USER_ANALYSIS = "setUserAnalysis";

export const SET_SURVEYS_LIST = "setSurveysList";

export const SET_LOCALE = "setLocale";


// WEBPACK FOOTER //
// ./src/store/mutations.js